var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-general"},[_c('y-pro-form',{staticStyle:{"width":"100%"},attrs:{"label-width":"280px","label-position":"left","model":_vm.model,"fields":_vm.fields,"submitter":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }